import axios from 'axios';
import { BASE_API_URL } from "../utils/api-url";

export async function getPermissions(accessToken) {
  const result = await axios.get(`${BASE_API_URL}/permissions`, {
    headers: {
      Authorization: `Bearer ${accessToken}`,
    },
  });

  return result.data;
}
